const MOBILE_BREAKPOINT = '(max-width: 749px)';
const SECTION_ID_SUFFIXES = ['__section_WRq6AP', '__section_EPBBjK', '__section_8qwnzx'];
const AUTOSLIDE_DELAY = 3000;
const CONTENT_MARKERS = [
  ['HOW IT WORKS', 'Step 1'],
  ['Change heads regularly for hygiene', 'Save on every order'],
  ['BETTER FOR YOU. BETTER FOR THE LONG TERM.', 'History & Culture'],
];

function getCardsTrack(section) {
  const tracks = section.querySelectorAll(
    '.group-block-content.layout-panel-flex.layout-panel-flex--row, .section-content-wrapper.layout-panel-flex--row'
  );
  for (const track of tracks) {
    const cardChildren = Array.from(track.children).filter(
      (child) =>
        child.classList.contains('group-block') ||
        child.matches('[data-testid="group-block"]') ||
        child.classList.contains('column')
    );
    if (cardChildren.length >= 3) {
      return { track, cards: cardChildren };
    }
  }

  return { track: null, cards: [] };
}

function setupSectionAutoSlide(section) {
  if (section.dataset.mobileHowItWorksAutoslideInit === 'true') return;

  const { track, cards } = getCardsTrack(section);
  if (!track || cards.length < 2) return;

  section.dataset.mobileHowItWorksAutoslideInit = 'true';
  track.classList.add('mobile-card-carousel-track');

  const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
  let timer = null;
  let currentIndex = 0;
  let resumeTimeout = null;

  const clearTimer = () => {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  };

  const clearResumeTimeout = () => {
    if (!resumeTimeout) return;
    window.clearTimeout(resumeTimeout);
    resumeTimeout = null;
  };

  const slideToIndex = (index, smooth = true) => {
    if (!cards[index]) return;

    const card = cards[index];
    const centeredLeft = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    const targetLeft = Math.min(Math.max(0, centeredLeft), Math.max(0, maxScrollLeft));

    track.scrollTo({
      left: targetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
  };

  const nextSlide = () => {
    if (!mediaQuery.matches) return;
    currentIndex = (currentIndex + 1) % cards.length;
    slideToIndex(currentIndex);
  };

  const previousSlide = () => {
    if (!mediaQuery.matches) return;
    currentIndex = (currentIndex - 1 + cards.length) % cards.length;
    slideToIndex(currentIndex);
  };

  const startTimer = () => {
    clearTimer();
    clearResumeTimeout();
    if (!mediaQuery.matches) return;
    timer = window.setInterval(nextSlide, AUTOSLIDE_DELAY);
  };

  const syncWithScroll = () => {
    const midpoint = track.scrollLeft + track.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card, index) => {
      const cardMidpoint = card.offsetLeft + card.clientWidth / 2;
      const distance = Math.abs(cardMidpoint - midpoint);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    currentIndex = closestIndex;
  };

  const pauseAndResume = () => {
    clearTimer();
    clearResumeTimeout();
    resumeTimeout = window.setTimeout(startTimer, AUTOSLIDE_DELAY);
  };

  const createNavigation = () => {
    const trackWrapper = track.parentElement;
    if (!trackWrapper) return;
    if (trackWrapper.querySelector('.how-it-works-mobile-nav')) return;

    trackWrapper.classList.add('how-it-works-mobile-track-wrap');

    const nav = document.createElement('div');
    nav.className = 'how-it-works-mobile-nav';

    const prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'how-it-works-mobile-nav__button how-it-works-mobile-nav__button--prev';
    prevButton.setAttribute('aria-label', 'Previous slide');
    prevButton.textContent = '◀';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'how-it-works-mobile-nav__button how-it-works-mobile-nav__button--next';
    nextButton.setAttribute('aria-label', 'Next slide');
    nextButton.textContent = '▶';

    prevButton.addEventListener('click', () => {
      previousSlide();
      startTimer();
    });

    nextButton.addEventListener('click', () => {
      nextSlide();
      startTimer();
    });

    nav.append(prevButton, nextButton);
    trackWrapper.append(nav);
  };

  track.addEventListener('scroll', syncWithScroll, { passive: true });
  track.addEventListener('touchstart', clearTimer, { passive: true });
  track.addEventListener('touchend', pauseAndResume, { passive: true });
  track.addEventListener('pointerdown', clearTimer, { passive: true });
  track.addEventListener('pointerup', pauseAndResume, { passive: true });

  window.addEventListener('resize', () => {
    if (!mediaQuery.matches) {
      clearTimer();
      clearResumeTimeout();
      return;
    }

    slideToIndex(currentIndex, false);
    startTimer();
  });

  createNavigation();
  startTimer();
}

function initHowItWorksMobileAutoSlide() {
  const sectionsToInit = new Set();

  SECTION_ID_SUFFIXES.forEach((suffix) => {
    const sections = document.querySelectorAll(`[id$='${suffix}']`);
    sections.forEach((section) => sectionsToInit.add(section));
  });

  const allSections = document.querySelectorAll('.shopify-section');
  allSections.forEach((section) => {
    const text = section.textContent || '';
    const isMatch = CONTENT_MARKERS.some(([a, b]) => text.includes(a) && text.includes(b));
    if (isMatch) sectionsToInit.add(section);

    if ((section.id || '').includes('section_8qwnzx')) {
      sectionsToInit.add(section);
    }
  });

  sectionsToInit.forEach(setupSectionAutoSlide);

  const explicitMultiColumnSection = document.querySelector('[id*="section_8qwnzx"]');
  if (explicitMultiColumnSection) {
    setupSectionAutoSlide(explicitMultiColumnSection);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHowItWorksMobileAutoSlide, { once: true });
} else {
  initHowItWorksMobileAutoSlide();
}

document.addEventListener('shopify:section:load', () => {
  initHowItWorksMobileAutoSlide();
});
